import React from 'react';
import { Text, Platform } from './ReactNativeCore';
import * as LucideIcons from 'lucide-react';

interface IoniconsProps {
  name: string;
  size?: number;
  color?: string;
}

// Web fallback for Ionicons using lucide-react
const WebIonicons: React.FC<IoniconsProps> & { Icon: React.FC<IoniconsProps> } = ({
  name,
  size = 24,
  color = 'black',
}) => {
  const IconComponent = (LucideIcons as any)[name.charAt(0).toUpperCase() + name.slice(1).replace(/-([a-z])/g, (g) => g[1].toUpperCase())] || LucideIcons.Smile;

  return <IconComponent size={size} color={color} />;
};

WebIonicons.Icon = WebIonicons;

export const Ionicons: React.FC<IoniconsProps> & { Icon: React.FC<IoniconsProps> } = Platform.OS === 'web' ? WebIonicons : ({
  name,
  size = 24,
  color = 'black',
}) => {
  // For non-web, keep the simple Text placeholder for now, or integrate a native icon library.
  return <Text style={{ fontSize: size, color }}>[Icon: {name}]</Text>;
};
